import './normalize.css';

import { Poppins, Roboto } from 'next/font/google';
import React from 'react';

export const heebo = Roboto({
    subsets: ['latin', 'cyrillic'],
    weight: ['400', '500'],
    display: 'swap',
});

export const poppins = Poppins({
    subsets: ['latin', 'latin-ext'],
    weight: ['300', '500', '600', '700'],
    display: 'swap',
});

export const GlobalStyle = ({ children }: { children: React.ReactNode }) => (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>{children}</>
);
